import { SplitFactory } from '@splitsoftware/splitio'
import logger from '../helpers/logger'

let factory = null
let manager = null
const clients = {}

export default function getClient (splitIoKey, trafficKey) {
  logger.debug('[FeatureFlags:SplitIO] Getting Split.io client', {
    trafficKey,
    hasExistingClient: !!clients[trafficKey]
  })

  if (clients[trafficKey]) {
    return Promise.resolve({
      client: clients[trafficKey],
      manager
    })
  }

  const factory = splitFactory(splitIoKey, trafficKey)
  const client = factory.client(trafficKey)

  return new Promise((resolve, reject) => {
    client.on(client.Event.SDK_READY, () => {
      logger.debug('[FeatureFlags:SplitIO] SDK ready', {
        trafficKey
      })
      clients[trafficKey] = client
      resolve({
        client, manager
      })
    })

    client.on(client.SDK_READY_TIMED_OUT, () => {
      logger.error('[FeatureFlags:SplitIO] SDK ready timed out', {
        trafficKey
      })
      reject(new Error('sdk_timeout'))
    })
  })
}

function splitFactory (splitIoKey, trafficKey) {
  if (factory === null) {
    logger.debug('[FeatureFlags:SplitIO] Initializing Split.io factory', {
      trafficKey,
      authKeyPresent: !!splitIoKey
    })

    factory = SplitFactory({
      core: {
        authorizationKey: splitIoKey,
        key: trafficKey
      },
      startup: {
        retriesOnFailureBeforeReady: 3
      }
    })

    manager = factory.manager()
    logger.debug('[FeatureFlags:SplitIO] Factory initialized successfully')
  } else {
    logger.debug('[FeatureFlags:SplitIO] Reusing existing factory', {
      trafficKey
    })
  }

  return factory
}
